import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Hero() {
  const scrollToForm = () => {
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center text-white overflow-hidden" data-id="element-33">
      {/* Background Image with Overlays */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1200")'
    }} data-id="element-34">
        <div className="absolute inset-0 bg-deep-blue/80 mix-blend-multiply" data-id="element-35"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-deep-blue/50 to-black/60" data-id="element-36"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center py-20" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-38">
          <span className="inline-block py-1 px-3 rounded-full bg-vitality-green/20 border border-vitality-green/50 text-vitality-green-100 text-sm font-medium tracking-wide mb-6" data-id="element-39">
            Seguridad Financiera Familiar
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight tracking-tight" data-id="element-40">
            Protege a tu familia y haz crecer tus ahorros{' '}
            <span className="text-vitality-green" data-id="element-41">sin riesgo</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-42">
          Descubre cómo un IUL combina protección, ahorro garantizado y
          tranquilidad para el futuro de los tuyos.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-10 text-sm md:text-base text-gray-300 font-medium" data-id="element-43">
          <div className="flex items-center gap-2" data-id="element-44">
            <Check className="w-5 h-5 text-vitality-green" data-id="element-45" />
            <span data-id="element-46">Sin riesgo de pérdida</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-47">
            <Check className="w-5 h-5 text-vitality-green" data-id="element-48" />
            <span data-id="element-49">Beneficios en vida</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-50">
            <Check className="w-5 h-5 text-vitality-green" data-id="element-51" />
            <span data-id="element-52">Asesoría en español</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-53">
          <button onClick={scrollToForm} className="bg-vitality-green hover:bg-vitality-green-hover text-white font-semibold py-4 px-10 rounded-full text-lg transition-all duration-300 shadow-[0_0_20px_rgba(45,140,78,0.4)] hover:shadow-[0_0_30px_rgba(45,140,78,0.6)] transform hover:-translate-y-1" data-id="element-54">
            Obtén tu guía gratuita
          </button>
          <p className="mt-4 text-sm text-gray-300 font-light" data-id="element-55">
            Toma menos de 1 minuto. Sin compromisos.
          </p>
        </motion.div>
      </div>
    </section>;
}